<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="800"
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="删除eSIM"
      @ok="handleSubmit"
    >
      <a-row>
        <a-form class="simiot-compact-form" :form="form" @submit="handleSubmit">
          <a-col :span="24">
            <a-form-item :wrapper-col="{ span: 24 }">
              <a-textarea
                :rows="15"
                :placeholder="eidPlaceholder"
                :style="{ color: eidValidateStatus === 'error' ? 'red' : '' }"
                v-model.trim="eidInput"
                @blur="analyzeEidInput"
              />
            </a-form-item>
            <a-form-item label="EID总数" :style="{ display: 'inline-block', width: '50%' }">
              <span>{{ eidsCount }}</span>
            </a-form-item>
            <a-form-item label="重复数量" :style="{ display: 'inline-block', width: '50%' }">
              <span>{{ duplicateEidsCount }}</span>
            </a-form-item>
            <div v-if="eidErrorMsg" style="color: red">{{ eidErrorMsg }}</div>
          </a-col>
          <a-col :span="24">
            <a-form-item label="备注">
              <a-textarea
                v-decorator="['remark', { rules: [{ max: 200, message: '最多200个字符' }] }]"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
            </a-form-item>
          </a-col>
        </a-form>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { destroyEsimInventories } from '@/api/esim_inventory'
import { analyzeEids, maxEidLines } from '@/utils/eid'

export default {
  name: 'BatchOperationsDestroyEsimInventory',
  props: {
    visible: { type: Boolean, required: true },
    eids: { type: Array, default() { return [] } }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'destroy_esim_inventory' }),
      submitting: false,
      eidInput: (this.eids || []).join('\n'),
      parsedEids: [],
      eidsCount: 0,
      duplicateEidsCount: 0,
      eidValidateStatus: '',
      eidErrorMsg: '',
      eidPlaceholder: '可以直接复制excel中整列EID；\n' +
        '手动输入多个EID，一行一个，EID固定32位；\n' +
        '连号的EID只需要输入最后几位不一样的即可，用波浪线连接。\n' +
        '例如: 89049032005008820000000000000100~150'
    }
  },
  computed: {
    isShow: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  },
  created() {
    if (this.eidInput) {
      this.analyzeEidInput()
    }
  },
  methods: {
    analyzeEidInput() {
      if (!this.eidInput) {
        this.parsedEids = []
        this.eidsCount = 0
        this.duplicateEidsCount = 0
        this.eidValidateStatus = 'error'
        this.eidErrorMsg = '请输入 EID'
        return
      }

      const { lines, validEids, errorText } = analyzeEids(this.eidInput)
      if (lines > maxEidLines) {
        this.parsedEids = []
        this.eidsCount = 0
        this.duplicateEidsCount = 0
        this.eidValidateStatus = 'error'
        this.eidErrorMsg = `EID数量不能超过${maxEidLines}`
        return
      }

      this.eidInput = errorText + validEids.join('\n')
      this.parsedEids = this.$lodash.uniq(validEids)
      this.eidsCount = validEids.length
      this.duplicateEidsCount = validEids.length - this.parsedEids.length

      if (errorText) {
        this.eidValidateStatus = 'error'
        this.eidErrorMsg = '号码包含错误，无法提交（EID须为32位）'
      } else if (this.parsedEids.length === 0) {
        this.eidValidateStatus = 'error'
        this.eidErrorMsg = '请输入 EID'
      } else if (this.duplicateEidsCount > 0) {
        this.eidValidateStatus = 'error'
        this.eidErrorMsg = '录入的 EID 存在重复'
      } else {
        this.eidValidateStatus = 'success'
        this.eidErrorMsg = ''
      }
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({ title: '请勿重复提交', content: '' })
        return
      }
      this.analyzeEidInput()
      if (this.eidValidateStatus === 'error') {
        return
      }
      this.form.validateFields((err, values) => {
        if (err) return
        this.submitting = true
        destroyEsimInventories({ eids: this.parsedEids, remark: values.remark || '' }).then((res) => {
          if (res.code === 0) {
            this.isShow = false
            this.$emit('completed')
            this.$success({
              title: '提交成功',
              content: (<div><p>删除任务已提交，请在批量操作查询中查看结果</p></div>)
            })
          }
          this.submitting = false
        }).catch(() => { this.submitting = false })
      })
    }
  }
}
</script>
